//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

/* Imports */
var Meteor = Package.meteor.Meteor;
var global = Package.meteor.global;
var meteorEnv = Package.meteor.meteorEnv;
var DDP = Package['ddp-client'].DDP;
var _ = Package.underscore._;

/* Package-scope variables */
var Cluster, ConnectionWatcher;

(function(){

//////////////////////////////////////////////////////////////////////////////////////////
//                                                                                      //
// packages/meteorhacks_cluster/packages/meteorhacks_cluster.js                         //
//                                                                                      //
//////////////////////////////////////////////////////////////////////////////////////////
                                                                                        //
(function () {                                                                          // 1
                                                                                        // 2
////////////////////////////////////////////////////////////////////////////////////    // 3
//                                                                                //    // 4
// packages/meteorhacks:cluster/lib/namespace.js                                  //    // 5
//                                                                                //    // 6
////////////////////////////////////////////////////////////////////////////////////    // 7
                                                                                  //    // 8
Cluster = {};                                                                     // 1  // 9
////////////////////////////////////////////////////////////////////////////////////    // 10
                                                                                        // 11
}).call(this);                                                                          // 12
                                                                                        // 13
                                                                                        // 14
                                                                                        // 15
                                                                                        // 16
                                                                                        // 17
                                                                                        // 18
(function () {                                                                          // 19
                                                                                        // 20
////////////////////////////////////////////////////////////////////////////////////    // 21
//                                                                                //    // 22
// packages/meteorhacks:cluster/lib/connection_watcher.js                         //    // 23
//                                                                                //    // 24
////////////////////////////////////////////////////////////////////////////////////    // 25
                                                                                  //    // 26
ConnectionWatcher = function ConnectionWatcher(discovery, serviceName, options) { // 1  // 27
  options = options || {};                                                        // 2  // 28
                                                                                  // 3  // 29
  this._discovery = discovery;                                                    // 4  // 30
  this._serviceName = serviceName;                                                // 5  // 31
  this._query = options.query || {};                                              // 6  // 32
  this._ddpOptions = options.ddpOptions;                                          // 7  // 33
  this._watchTimeout = options.watchTimeout || 5 * 1000;                          // 8  // 34
                                                                                  // 9  // 35
  this._currUrl = null;                                                           // 10
  this._ddpUrls = {};                                                             // 11
                                                                                  // 12
  this._connection = DDP.connect(this._getDefaultURL(), this._ddpOptions);        // 13
  this._connection.disconnect();                                                  // 14
  this._newConnectionWatcher = this._watchForNewConnections();                    // 15
};                                                                                // 16
                                                                                  // 17
ConnectionWatcher.prototype.getConnection = function() {                          // 18
  return this._connection;                                                        // 19
};                                                                                // 20
                                                                                  // 21
ConnectionWatcher.prototype._getDefaultURL = function() {                         // 22
  if(Meteor.isServer) {                                                           // 23
    return "";                                                                    // 24
  } else {                                                                        // 25
    return location.origin;                                                       // 26
  }                                                                               // 27
};                                                                                // 28
                                                                                  // 29
ConnectionWatcher.prototype._watchForNewConnections = function() {                // 30
  var self = this;                                                                // 31
  var connectInitially = false;                                                   // 32
                                                                                  // 33
  setConnectionIfNeeded();                                                        // 34
  // to make sure, we are connecting again                                        // 35
  var timeoutHandler =                                                            // 36
    Meteor.setInterval(setConnectionIfNeeded, self._watchTimeout);                // 37
                                                                                  // 38
  function setConnectionIfNeeded() {                                              // 39
    var status = self._connection.status();                                       // 40
    // do not reconnect again, if disconnected manually                           // 41
    // but not at the first time since we do it manually                          // 42
    // until we pick an endpoint                                                  // 43
    var isOffline = connectInitially && status.status == "offline";               // 44
    if(!status.connected && !isOffline) {                                         // 45
      var url = self._discovery.pickEndpoint(self._serviceName);                  // 46
      if(url) {                                                                   // 47
        self._connection.reconnect({url: url});                                   // 48
        connectInitially = true;                                                  // 49
      }                                                                           // 50
    }                                                                             // 51
  }                                                                               // 52
                                                                                  // 53
  var returnContext = {                                                           // 54
    stop: function() {                                                            // 55
      Meteor.clearTimeout(timeoutHandler);                                        // 56
    }                                                                             // 57
  };                                                                              // 58
                                                                                  // 59
  return returnContext;                                                           // 60
};                                                                                // 61
////////////////////////////////////////////////////////////////////////////////////    // 88
                                                                                        // 89
}).call(this);                                                                          // 90
                                                                                        // 91
                                                                                        // 92
                                                                                        // 93
                                                                                        // 94
                                                                                        // 95
                                                                                        // 96
(function () {                                                                          // 97
                                                                                        // 98
////////////////////////////////////////////////////////////////////////////////////    // 99
//                                                                                //    // 100
// packages/meteorhacks:cluster/lib/client/api.js                                 //    // 101
//                                                                                //    // 102
////////////////////////////////////////////////////////////////////////////////////    // 103
                                                                                  //    // 104
Cluster.discoverConnection = function(serviceName) {                              // 1  // 105
  return DDP.connect("/" + serviceName);                                          // 2  // 106
};                                                                                // 3  // 107
////////////////////////////////////////////////////////////////////////////////////    // 108
                                                                                        // 109
}).call(this);                                                                          // 110
                                                                                        // 111
//////////////////////////////////////////////////////////////////////////////////////////

}).call(this);


/* Exports */
if (typeof Package === 'undefined') Package = {};
(function (pkg, symbols) {
  for (var s in symbols)
    (s in pkg) || (pkg[s] = symbols[s]);
})(Package['meteorhacks:cluster'] = {}, {
  Cluster: Cluster
});

})();



/*****************
 ** WEBPACK FOOTER
 ** ./build/meteor/bundle/programs/web.browser/packages/meteorhacks_cluster.js
 ** module id = ./build/meteor/bundle/programs/web.browser/packages/meteorhacks_cluster.js
 ** module chunks = 0 1
 **/